/* Custom element for the "Read More" button
  * This element is used to create a button that will show/hide a section of text
*/

if (!customElements.get('read-more')) {
  customElements.define('read-more', class extends HTMLElement {
    constructor() {
      super();

      this.settings = {
        // Calculate the max height based on the max number of lines and the line height
        maxHeight: this.maxHeight,
        // get --button-height from CSS
        buttonHeight: (parseInt(getComputedStyle(this).getPropertyValue('--button-height'), 10) + 0.2) * 10
      }
    }

    connectedCallback() {
      // Check if the content overflow the max height
      if (this.scrollHeight <= (this.settings.maxHeight + 1)) return;
      const height = this.settings.maxHeight + this.settings.buttonHeight + 60 + 'px';
      this.style.maxHeight = height;
      this.style.minHeight = height;
      this.classList.add('read-more--init');
      this.button.addEventListener('click', this.toggle.bind(this));
    }

    get maxHeight() {
      let firstElement = this.firstElementChild;
      let maxHeight = firstElement ? firstElement.getBoundingClientRect().height : 0;
      return maxHeight;
    }

    toggle() {
      this.classList.toggle('read-more--open');
      this.button.setAttribute('aria-expanded', this.classList.contains('read-more--open'));
    }

    get button() {
      return this.querySelector('button');
    }
  });
}
